import { makeAutoObservable } from "mobx";
import { createMutations } from "./mutations";
import { initialState } from "./state";
import formReportActions from "./actions";

const formReportStore = () => {
  const store = {
    ...initialState,
    ...formReportActions
  };

  const mutations = createMutations(store);
  Object.assign(store, mutations);
  
  makeAutoObservable(store);
  return store;
};

export default formReportStore();